// zod v4 probes `new Function('')` on its first object parse to decide whether
// to JIT-compile parsers. pdfmarkuptool.com's enforced Content-Security-Policy
// has no 'unsafe-eval' (firebase.json, docs/hosting-headers.md), so the probe
// would log a CSP violation on every page load. Jitless = the same results via
// zod's interpreter. Imported FIRST by main.tsx, before any schema can parse.
import { config } from 'zod';

config({ jitless: true });
